import { createFileRoute, getRouteApi } from "@tanstack/react-router";

import { CoachProfileSections } from "~/components/coach-profile/profile-sections";
import { Skeleton } from "~/components/ui/skeleton";
import { coachQueryOptions } from "~/lib/query-options";

const parentRoute = getRouteApi("/_public/discovery/$username");

export const Route = createFileRoute("/_public/discovery/$username/")({
  loader: async ({ context, params }) => {
    // The other offers are fetched after hydration otherwise, so that section
    // would appear late and push the rest of the page down. The parent loader
    // has already loaded the coach into the query cache. prefetchQuery ignores
    // `enabled`, so honour it here: only Pro+ coaches show other offers.
    const coach = await context.queryClient.ensureQueryData(
      coachQueryOptions.byUsername(params.username),
    );
    if (!coach?.id) return;

    const otherOffers = coachQueryOptions.otherOffers(
      coach.id,
      coach.membershipPlan ?? undefined,
    );
    if (otherOffers.enabled) {
      await context.queryClient.prefetchQuery(otherOffers);
    }
  },
  component: CoachProfilePage,
});

function CoachProfileSkeleton() {
  return (
    <div
      role="status"
      aria-label="Loading coach profile"
      className="space-y-12 px-4 py-8"
    >
      {[0, 1, 2].map((i) => (
        <div key={i} className="space-y-4">
          <Skeleton className="h-8 w-48" />
          <Skeleton className="h-4 w-full" />
          <Skeleton className="h-4 w-5/6" />
          <Skeleton className="h-4 w-4/5" />
        </div>
      ))}
    </div>
  );
}

function CoachProfilePage() {
  const { coach } = parentRoute.useLoaderData();

  if (!coach?.profile) {
    return <CoachProfileSkeleton />;
  }

  return <CoachProfileSections coach={coach} />;
}
